import imageLogin from "../Asset/loginBanner.svg"
import loginLogo from "../Asset/loginLogo.svg"
import headerLogo from "../Asset/HeaderLogo.svg"
const Images = {
  Raise: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/Group%2048099673.png',
  Education: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/education.png',
  Medal: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/medal-star.png',
  Credit: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/two_credit_cart.png',
  DefaultProfileImage: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/profile.png',
  DefaultOrganizationLogo: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/ken42(png).png',
  AuthLayoutBg: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/LoginBackground.png',
  NoDataTheme: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/noEvents.png',
  PostEventBanner: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/Plant.png',
  PostJobBanner: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/PostJob.png',
  EventCardCoverImage: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/noimage.jpg',
  OnBoardBg: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/backgroundonboard.png',
  Complain: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/Objects.png',
  BeginSurvey: 'https://alumnikenverse.blob.core.windows.net/images/survey.png',
  CreateSurvey: 'https://alumnikenverse.blob.core.windows.net/images/create-survey.png',
  SurveyThankYou: 'https://alumnikenverse.blob.core.windows.net/images/survey-thankyou.png',
  entreprenursOfKen42: 'https://alumnikenverse.blob.core.windows.net/images/pioneers of ken42.png',
  imageLogin: imageLogin,
  loginLogo: loginLogo,
  headerLogo: headerLogo
};
const Svg = {};
const Icons = {
  Error: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/error.png',
  DefaultServiceIcon: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/education.png',
  Location: 'https://alumnikenverse.blob.core.windows.net/images/Group.png',
  Designation: 'https://alumnikenverse.blob.core.windows.net/images/designation.png',
  Like: 'https://alumnikenverse.blob.core.windows.net/images/like.png',
  Share: 'https://alumnikenverse.blob.core.windows.net/images/share.png',
  Comment: 'https://alumnikenverse.blob.core.windows.net/images/comment.png',
  ArrowForward: 'https://alumnikenverse.blob.core.windows.net/images/arrowForward.png',
  Check: 'https://alumnikenverse.blob.core.windows.net/images/Check.png',
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { Images, Icons, Svg };
